export interface Faq {
  id: string;
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    id: "f1",
    q: "《师兄啊师兄》到底是什么类型的漫画？",
    a: "它是一部以修仙为题材的国漫，主打修炼日常、宗门成长与主线剧情并行的叙事风格。既有轻松搞笑的同门互动，也有扣人心弦的战斗与伏笔，属于轻喜剧与热血修仙结合的类型。",
  },
  {
    id: "f2",
    q: "宗门篇大概讲的是什么样的故事？",
    a: "宗门篇承接主角拜入山门的起点，围绕宗门日常、历练成长与内部矛盾三条线展开。它既交代了世界观，也让主角团完成重要成长，是理解后续主线走向的关键章节。",
  },
  {
    id: "f3",
    q: "漫画里的修炼境界是怎么划分的？",
    a: "境界大致遵循炼气、筑基、金丹、元婴、化神、渡劫、大乘、飞升的阶梯。每一层都对应不同的灵气运用、实力与寿元上限，其中金丹被普遍视为踏入强者行列的分水岭。",
  },
  {
    id: "f4",
    q: "剧情讨论有剧透风险吗？",
    a: "我们会在文章标题与开头明确标注涉及到的剧情章节范围，讨论时会尽量先给阅读提示。如果担心剧透，建议先补到对应章节再进入讨论区，体验会更完整。",
  },
  {
    id: "f5",
    q: "在哪里可以看到最新章节？",
    a: "最新章节更新于漫画的官方连载平台，追更时请认准官方渠道。本站主要提供剧情解析、境界梳理与同好讨论，不提供任何非官方资源，还请支持正版。",
  },
  {
    id: "f6",
    q: "可以投稿自己的剧情分析吗？",
    a: "非常欢迎！你可以通过本页的留言表单或联系邮箱，把想分享的分析、伏笔发现或角色解读发给我们。审核通过后，我们会署上你的名字发布到对应栏目。",
  },
];